// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__Kxu9_","navText":"Navbar_navText__ph54Y","navLogo":"Navbar_navLogo__3zKOq","imgLogo":"Navbar_imgLogo__1l_f9"};